/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量16
 * @export
 * @interface Col16
 */
export interface Col16 {
}

/**
 * Check if a given object implements the Col16 interface.
 */
export function instanceOfCol16(value: object): value is Col16 {
    return true;
}

export function Col16FromJSON(json: any): Col16 {
    return Col16FromJSONTyped(json, false);
}

export function Col16FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col16 {
    return json;
}

export function Col16ToJSON(json: any): Col16 {
    return Col16ToJSONTyped(json, false);
}

export function Col16ToJSONTyped(value?: Col16 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

